import { useQuery } from '@tanstack/react-query'

import { groupByInvoice } from '@/frontend/features/billing/invoices.utils'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches paid orders for a member and groups them into invoice groups.
 * Each group represents a single Stripe invoice (shared paymentId).
 */
export function useListMemberInvoices(memberId: string, enabled = true) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['member-invoices', memberId],
    enabled,
    queryFn: async () => {
      const response = await api.get('/orders', {
        query: { memberId, paymentStatus: ['paid'] },
      })
      if (!response.success) throw new Error(response.error.message)
      return groupByInvoice(response.data.orders)
    },
  })
}
